export const SAVEMESSAGE = 'SAVEMESSAGE';
export const REMOVEMESSAGE = 'REMOVEMESSAGE';